<template>
<div class="amf-collection-row">
    <amf-form-row
        :label="label"
        :edit-summary="editSummary"
        :view-summary="viewSummaryInternal"
        buttons="Close"
        :onSave="save"
        :onCancel="cancel"
        :onEdit="edit"
        :addItem="addItem">
        <div class="col-12">
            <ul v-if="items.length > 0">
                <li v-for="item in items" :key="item.id">
                    <div v-if="item.component">
                        <div :item="item" :is="item.component"></div>
                    </div>
                    <div v-else-if="item.action === 'Info'">
                        {{ item.text }}
                    </div>
                    <div v-else-if="item.action !== 'Add'">
                        <a
                            href="#"
                            v-on:click.prevent="$emit('click', item)"
                        >
                            <span :class="['fa', item.icon]"></span>
                        {{item.linkText || item.text}}</a>{{item.linkText ? item.text.slice(item.linkText.length) : ""}}
                    </div>
                </li>
            </ul>
        </div>
    </amf-form-row>
</div>
</template>

<script>
export default {
    props: ["label", "items", "viewSummary", "editSummary"],
    data() {
        return { };
    },
    computed: {
        viewSummaryInternal(){
            if (!_.isUndefined(this.viewSummary)) return this.viewSummary;
            
            const SUMMARY_LENGTH = 100;
            let its = this.items
                .filter(z => z.action !== 'Add')
                .filter(y => y.linkText || y.text)
                .map(x => x.linkText || x.text)
                .join(', ')
                .slice(0, SUMMARY_LENGTH);
            if (its.length === 0) {its = "None"}
            return its.length >= SUMMARY_LENGTH ? its + "..." : its;
        },
        addItem() {
            if (!this.items) return;
            return _.find(this.items, { 'action': 'Add' });
        },
    },
    methods: {
        save(){},
        cancel(){},
        edit(){},
    },
}
</script>

<style lang="scss" scoped>
    .amf-collection-row {
        ul {
            margin-bottom: 0;
            padding: 0;
            list-style-type: none;
        }
        li:not(:last-child) {
            margin-bottom: 0.75rem;
        }
        a {
            color: black;
        }
    }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfCollectionRow.vue